// src/components/FailedAgainDialog.jsx
// "Your fax failed again" (3.57.7, owner): when a person's own send fails
// again to the same number (the 2nd or later failure within an hour), this
// window opens and stays until they close it, so they check the number or
// the receiver before trying again. Nothing is blocked; it only explains.
// Wording approved by the owner (Oct 13).
import MenuDialog from './MenuDialog';
import { formatFax } from '../utils/format';
import { reasonText, reasonWhy, repeatAdvice } from '../utils/faxReasons';

export default function FailedAgainDialog({ ev, onOpenFax, onClose }) {
  const num = formatFax(ev.number);
  const n = ev.repeat || 2;
  const advice = repeatAdvice(ev.failureReason);
  return (
    <MenuDialog id="failed-again" icon="❌" title={`Your fax to ${num} failed again: ${n} times in the last hour`} onClose={onClose} width={560}>
      <div style={S.box}>
        <p style={S.p}><strong style={S.red}>Reason:</strong> {reasonText(ev.failureReason, ev.failureContext)}.</p>
        {reasonWhy(ev.failureReason, ev.failureContext) && <p style={S.p}><strong style={S.red}>Why this happened:</strong> {reasonWhy(ev.failureReason, ev.failureContext)}</p>}
        {advice && <p style={S.p}><strong style={S.red}>What to do:</strong> {advice}</p>}
      </div>
      <div style={S.actions}>
        <button onClick={() => { onOpenFax(ev); onClose(); }} style={S.secondary}>Open this fax</button>
        <button onClick={onClose} style={S.primary}>OK, I'll check</button>
      </div>
    </MenuDialog>
  );
}

const S = {
  box: { background: 'var(--c-ffebee)', border: '1px solid var(--c-ef9a9a)', borderRadius: 10, padding: '12px 16px', margin: '4px 0 16px' },
  p: { margin: '6px 0', fontSize: 14, lineHeight: 1.55, color: 'var(--t-37474f)' },
  red: { color: 'var(--t-b71c1c)' },
  actions: { display: 'flex', gap: 10, justifyContent: 'flex-end', flexWrap: 'wrap' },
  primary: { padding: '9px 18px', background: 'var(--c-00897b)', color: 'var(--t-ffffff)', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600, fontFamily: 'inherit' },
  secondary: { padding: '9px 18px', background: 'var(--c-ffffff)', color: 'var(--t-00695c)', border: '1.5px solid var(--c-b2dfdb)', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600, fontFamily: 'inherit' },
};
